import React from "react";
import { Button, Spinner } from "react-bootstrap";
import { FaSave } from "react-icons/fa";

/**
 * Botão Salvar padronizado (ícone disquete + Spinner ao carregar).
 * Uso em modais e formulários.
 *
 * @param {Function} onClick - Handler ao clicar
 * @param {boolean} [loading=false] - Se true, mostra Spinner e desabilita
 * @param {boolean} [disabled=false] - Desabilita o botão
 * @param {string} [className='modal-footer-btn-salvar'] - Classes CSS adicionais
 * @param {string} [title='Salvar'] - title para acessibilidade
 * @param {number} [iconSize=18] - Tamanho do ícone em px
 */
function Salvar({
  onClick,
  loading = false,
  disabled = false,
  className = "modal-footer-btn-salvar",
  title = "Salvar",
  iconSize = 18,
  ...rest
}) {
  return (
    <Button
      variant="success"
      className={className}
      onClick={onClick}
      disabled={disabled || loading}
      title={title}
      {...rest}
    >
      {loading ? (
        <Spinner animation="border" size="sm" />
      ) : (
        <FaSave size={iconSize} />
      )}
    </Button>
  );
}

export default Salvar;
